
document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('custom-video')) {
    class OptimizedVideo extends HTMLElement {
      videoElement;
      resizeObserver;
      intersectionObserver;
      isInViewport = false;

      static get observedAttributes() {
        return ['data-src', 'data-src-m'];
      }

      constructor() {
        super();
        this.handleResize = this.throttle(this.handleResize.bind(this), 100);
        this.handleIntersection = this.handleIntersection.bind(this);
      }

      connectedCallback() {
        this.initializeDOM();
        this.setupObservers();
        this.loadIfVisible();
      }

      disconnectedCallback() {
        this.cleanup();
      }

      attributeChangedCallback() {
        if (this.isInViewport) {
          this.updateVideoSource();
        }
      }

      initializeDOM() {
        this.videoElement = this.querySelector('video');
        if (!this.videoElement) {
          console.warn('Missing video element inside optimized-video');
          return;
        }
        
        this.videoElement.preload = 'auto';
        this.videoElement.playsInline = true;
        this.videoElement.muted = true; 
      }

      setupObservers() {

        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(document.documentElement);


        this.intersectionObserver = new IntersectionObserver(entries => {
          entries.forEach(this.handleIntersection);
        }, { threshold: 0.1 });
        this.intersectionObserver.observe(this);
      }

      handleIntersection(entry) {
        this.isInViewport = entry.isIntersecting;
        if (this.isInViewport) {
          this.updateVideoSource();
          if (this.videoElement.paused && this.videoElement.readyState >= 2) {
            this.videoElement.play().catch(e => {
              console.debug('Autoplay prevented:', e);
            });
          }
        } else {
          this.videoElement.pause();
        }
      }

      handleResize() {
        this.updateVideoSource();
      }

      updateVideoSource() {
        if (!this.isInViewport) return;

        const newSrc = this.getOptimalSource();
        const currentSrc = this.videoElement.currentSrc;

        if (newSrc && newSrc !== currentSrc) {
          this.swapSource(newSrc);
        }
      }

      getOptimalSource() {
        if (this.dataset.srcM) {
          const isMobile = window.innerWidth <= 849;
          return isMobile ? this.dataset.srcM : this.dataset.src;
        }else{
          return this.dataset.src;
        }
      }

      swapSource(src) {
        const source = document.createElement('source');
        source.src = src;
        source.type = this.getMimeType(src);

        const existingSource = this.videoElement.querySelector('source');
        if (existingSource) {
          existingSource.replaceWith(source);
        } else {
          this.videoElement.prepend(source);
        }

        this.videoElement.load();
        this.videoElement.play().catch(e => {
          console.debug('Autoplay prevented:', e);
        });
      }

      getMimeType(src) {
        const ext = src.split('.').pop();
        return {
          webm: 'video/webm',
          mp4: 'video/mp4',
          mov: 'video/quicktime',
          ogg: 'video/ogg'
        }[ext] || 'video/mp4';
      }

      loadIfVisible() {
        if (this.isInViewport) {
          this.updateVideoSource();
        }
      }

      throttle(fn, delay) {
        let lastCall = 0;
        return (...args) => {
          const now = Date.now();
          if (now - lastCall >= delay) {
            fn(...args);
            lastCall = now;
          }
        };
      }

      cleanup() {
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.videoElement?.pause();
        this.videoElement?.removeAttribute('src');
        this.videoElement?.load();
      }
    }

    customElements.define('custom-video', OptimizedVideo);
  }
})



